import axios from 'axios' // 引入axios
import {Message} from 'element-ui';
import {store, useGlobalStore, useMemberStore} from '@/pinia'
import Vue from 'vue'

Vue.use(store)

const globalStore = useGlobalStore()
const memberStore = useMemberStore()

const service = axios.create({
    baseURL: "/union_api",
    timeout: 99999
})

service.interceptors.request.use(
    config => {
        if (config.doShowLoading) {
            showLoading()
        }
        config.headers = {
            'Content-Type': 'application/json',
            "device-type": "web",
            "site": globalStore.site,
            "uuid": memberStore.uuid,
            "x-token": memberStore.token,
            "promotion": JSON.stringify(globalStore.promotion),
            ...config.headers
        }
        return config
    },
    error => {
        if (error.config.doShowLoading) {
            closeLoading()
        }
        Message({
            showClose: true,
            message: error,
            type: 'error'
        })
        return error
    }
)


let activeAxios = 0
let timer
const showLoading = () => {
    activeAxios++
    if (timer) {
        clearTimeout(timer)
    }
    timer = setTimeout(() => {
        globalStore.loading = true
    }, 400)
}
const closeLoading = () => {
    activeAxios--
    if (activeAxios <= 0) {
        clearTimeout(timer)
        globalStore.loading = false
    }
}

// http response 拦截器
service.interceptors.response.use(
    response => {
        if (response.config.doShowLoading) {
            closeLoading()
        }
        if (response.data.code == 0 || response.headers.success == 'true') {
            if (response.headers.msg) {
                response.data.msg = decodeURI(response.headers.msg)
            }
            return response.data
        } else {
            if (!response.config.hideErrMsg) {
                Message.error(response.data.msg)
            }
            return response.data.msg ? response.data : response
        }
    },
    error => {
        if (error.config.doShowLoading) {
            closeLoading()
        }

        if (error.config.hideErrMsg) {
            return error
        }

        if (!error.response) {
            Message.error("检测到请求错误")
            return
        }

        switch (error.response.status) {
            case 500:
                Message.error("检测到接口错误,500")
                break
            case 404:
                Message.error("检测到接口错误,404")
                break
            case 401:
                Message.error("登录信息失效，请刷新页面重新登录")
                break
        }

        return error
    }
)

export default service